var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgManualSyncIcon = function SvgManualSyncIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7779 11.1767C13.7779 12.2483 13.3523 13.276 12.5945 14.0337C11.8368 14.7914 10.8091 15.2171 9.73755 15.2171",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7577 9.66157V9.15652C11.7577 8.88863 11.6513 8.6317 11.4619 8.44227C11.2725 8.25284 11.0155 8.14642 10.7476 8.14642V8.14642C10.4798 8.14642 10.2228 8.25284 10.0334 8.44227C9.84397 8.6317 9.73755 8.88863 9.73755 9.15652",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.73724 9.15657V8.65152C9.73724 8.38362 9.63082 8.1267 9.44139 7.93727C9.25196 7.74784 8.99503 7.64142 8.72714 7.64142V7.64142C8.45924 7.64142 8.20232 7.74784 8.01289 7.93727C7.82346 8.1267 7.71704 8.38362 7.71704 8.65152V9.15657",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.71722 8.90402V6.12625C7.71722 5.85835 7.6108 5.60143 7.42137 5.412C7.23194 5.22257 6.97501 5.11615 6.70712 5.11615C6.43923 5.11615 6.1823 5.22257 5.99287 5.412C5.80344 5.60143 5.69702 5.85835 5.69702 6.12625V11.1767",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7579 9.66159C11.7579 9.39369 11.8643 9.13677 12.0537 8.94734C12.2432 8.75791 12.5001 8.65149 12.768 8.65149C13.0359 8.65149 13.2928 8.75791 13.4822 8.94734C13.6717 9.13677 13.7781 9.39369 13.7781 9.66159V11.1767C13.7781 12.2483 13.3524 13.276 12.5947 14.0337C11.837 14.7914 10.8093 15.2171 9.73769 15.2171H8.72759C7.31345 15.2171 6.45487 14.7828 5.70235 14.0353L3.88417 12.2171C3.7104 12.0247 3.61729 11.7728 3.62413 11.5136C3.63097 11.2544 3.73722 11.0077 3.9209 10.8247C4.10457 10.6417 4.35159 10.5363 4.61082 10.5304C4.87005 10.5245 5.12162 10.6184 5.31346 10.7929L6.20234 11.6818",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2425 5.62118C10.2425 3.5292 8.5466 1.83331 6.45462 1.83331C4.36263 1.83331 2.66675 3.5292 2.66675 5.62118C2.66675 6.61031 3.04588 7.51089 3.66675 8.18553",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgManualSyncIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/manual-sync-icon.74486b58.svg";
export { ForwardRef as ReactComponent };